import React, { useState, useEffect } from "react";
import { connect, useSelector } from "react-redux";
import { Box, Button } from "@mui/material";
import { Navigate, useLocation } from "react-router-dom";
import NumTrapsHauled from "../../components/NumTrapsHauled/NumTrapsHauled";
import NumTrapsInWater from "../../components/NumTrapsInWater/NumTrapsInWater";
import NumTrapsPerString from "../../components/NumTrapsPerString/NumTrapsPerString";
import NumBuoyLines from "../../components/NumBuoyLines/NumBuoyLines";
import StringsHauled from "../../components/StringsHauled/StringsHauled";
import AvgSoakTime from "../../components/AvgSoakTime/AvgSoakTime";
import { setError } from "../../actions/errorActions";
import { setRedirect } from "../../actions/newVtrTrip";
import { validateEffortSet4 } from "../../constants/effortValidations";
import { updateEffort } from "../../actions/newEffort";
import useDisplayLobsterQuestions from "../../constants/useDisplayLobsterQuestions";

function EffortPage4({
  auth,
  vtrTrip,
  updateEffort,
  setError,
  setTripRedirect,
}) {
  const location = useLocation();
  const { effortNr, trip: currentTrip } = location.state;
  const [effort, setEffort] = useState({ ...currentTrip.images[effortNr] });
  const { validation } = useSelector((state) => state);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setEffort({ ...effort, [name]: value });
  };

  const _cancel = (event) => {
    event.preventDefault();
    setError([]);
    setTripRedirect();
  };

  const _save = (event) => {
    event.preventDefault();
    const errors = validateEffortSet4(effort);
    if (errors.length > 0) {
      setError(errors);
      console.error("effort-page4", errors);
      return;
    }
    updateEffort(
      { ...effort, trip_id: currentTrip.trip_id, effortNr },
      auth.client_id
    );
  };
  const GearJson = validation.validations.gear;

  const [
    displayTrapsPerEffortQuestion,
    ,
    displayTrapsInWaterQuestion,
    ,
    displayLinesInWaterQuestion,
    ,
    displayTrapsPerStringQuestion,
    ,
    ,
    ,
    ,
    displayStringsHauledPerEffortQuestion,
    ,
    displayAverageSoakTimePerEffortQuestion,
  ] = useDisplayLobsterQuestions(currentTrip, effortNr, GearJson);

  if (vtrTrip.redirect === true) {
    return (
      <Navigate
        replace
        to={`${process.env.PUBLIC_URL}/effort-review`}
        state={{
          trip_id: currentTrip.trip_id,
          client_id: auth.client_id,
          effortNr: effortNr,
        }}
      />
    );
  }

  return (
    <>
      <Box display="flex" flexDirection={"column"} justifyContent="center">
        {displayTrapsInWaterQuestion && (
          <NumTrapsInWater
            numTrapsInWater={effort.numTrapsInWater}
            handleChange={handleInputChange}
          />
        )}
        {displayLinesInWaterQuestion && (
          <NumBuoyLines
            numBuoyLines={effort.numBuoyLines}
            handleChange={handleInputChange}
          />
        )}
        {displayTrapsPerEffortQuestion && (
          <NumTrapsHauled
            numTrapsHauled={effort.numTrapsHauled}
            handleChange={handleInputChange}
          />
        )}
        {displayStringsHauledPerEffortQuestion && (
          <StringsHauled
            stringsHauled={effort.stringsHauled}
            handleChange={handleInputChange}
          />
        )}
        {displayTrapsPerStringQuestion && (
          <NumTrapsPerString
            numTrapsPerString={effort.numTrapsPerString}
            handleChange={handleInputChange}
          />
        )}
        {displayAverageSoakTimePerEffortQuestion && (
          <AvgSoakTime
            avgSoakTime={effort.avgSoakTime}
            handleChange={handleInputChange}
          />
        )}
      </Box>
      <Box display="flex" justifyContent="center" m={1} p={1}>
        <Box p={1}>
          <Button variant="contained" className="warningBtn" onClick={_cancel}>
            Cancel
          </Button>
        </Box>
        <Box p={1}>
          <Button variant="contained" className="successBtn" onClick={_save}>
            Save
          </Button>
        </Box>
      </Box>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    vtrTrip: state.vtrTrip,
    auth: state.auth,
    helpText: state.helpText,
    error: state.error,
  };
};

const mapDispatchToProps = {
  setError,
  setTripRedirect: setRedirect,
  validateEffortSet4,
  updateEffort,
};

export default connect(mapStateToProps, mapDispatchToProps)(EffortPage4);
